import React from "react";
import { useTranslation } from "react-i18next";
import { formatTagForDisplay } from "../../data/assessmentFromServices";

const SliderControls = ({
  onPrevClick,
  onNextClick,
  onResetFilter,
  selectedTags,
  isPrevDisabled,
  isNextDisabled = false,
  currentIndex = 0,
  totalSlides = 0,
}) => {
  const { t } = useTranslation();
  const showCounter = totalSlides > 0;

  const prevArrow = (
    <svg
      key="prev"
      className={`services-picker__arrow services-picker__arrow--prev slick-arrow ${isPrevDisabled ? "slick-disabled" : ""}`}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={!isPrevDisabled ? onPrevClick : undefined}
      aria-disabled={isPrevDisabled}
    >
      <rect
        className="services-picker__arrow-circle"
        x="0.5"
        y="0.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="#07393C"
      />
      <path
        className="services-picker__arrow-icon"
        d="M20 12L12 20M20 28L12 20M12 20L28 20"
        stroke="#07393C"
      />
    </svg>
  );

  const nextArrow = (
    <svg
      key="next"
      className={`services-picker__arrow services-picker__arrow--next slick-arrow ${isNextDisabled ? "slick-disabled" : ""}`}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={!isNextDisabled ? onNextClick : undefined}
      aria-disabled={isNextDisabled}
    >
      <rect
        className="services-picker__arrow-circle"
        x="0.5"
        y="0.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="#07393C"
      />
      <path
        className="services-picker__arrow-icon"
        d="M20 28L28 20M20 12L28 20M28 20L12 20"
        stroke="#07393C"
      />
    </svg>
  );

  return (
    <div className="services-picker__controls vh-services-slider__controls">
      {showCounter ? (
        <div
          className="vh-services-slider__counter description-n"
          aria-live="polite"
          aria-atomic="true"
        >
          <span className="vh-services-slider__counter-current">
            {currentIndex + 1}
          </span>
          <span className="vh-services-slider__counter-sep" aria-hidden="true">
            /
          </span>
          <span className="vh-services-slider__counter-total">
            {totalSlides}
          </span>
          <span className="vh-services-slider__counter-label">
            {t("slider.servicesLabel")}
          </span>
        </div>
      ) : null}
      <div className="services-picker__arrows vh-services-slider__arrows">
        {prevArrow}
        {nextArrow}
      </div>
      {selectedTags.length > 0 ? (
        <div
          className="services-picker__clear services-picker__clear--show vh-services-slider__filter-panel"
          role="region"
          aria-label={t("slider.filtersRegion")}
        >
          <div className="vh-services-slider__filter-panel-inner">
            <div className="vh-services-slider__filter-panel-head">
              <span className="vh-services-slider__filter-panel-eyebrow">
                {t("slider.activeFilters")}
              </span>
              <p className="vh-services-slider__filter-panel-lede description-n">
                {t("slider.filtersLede")}
              </p>
            </div>
            <ul
              className="services-picker__clear-tags vh-services-slider__filter-tags"
              aria-label={t("slider.selectedCriteria")}
            >
              {selectedTags.map((tag, index) => (
                <li key={`${tag}-${index}`}>
                  <span className="services-picker__tag description-n vh-services-slider__filter-chip">
                    {formatTagForDisplay(tag, t)}
                  </span>
                </li>
              ))}
            </ul>
            <button
              type="button"
              className="services-picker__clear-btn description-n vh-services-slider__reset-btn"
              onClick={onResetFilter}
              aria-label={t("slider.resetAria")}
            >
              <svg
                className="vh-services-slider__reset-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M3 12a9 9 0 1 0 2.64-6.36"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path
                  d="M3 4v4h4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="vh-services-slider__reset-label">
                {t("slider.resetAll")}
              </span>
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SliderControls;
